(() => {
  if (window.__affirmPromoWidgetInitialized) return;
  window.__affirmPromoWidgetInitialized = true;

  const country = window.Shopify?.country;
  const locale = window.Shopify?.locale;

  const configs = {
    US: {
      public_api_key: 'U037MNEMTCH81DFJ',
      script: 'https://cdn1.affirm.com/js/v2/affirm.js',
      locale: 'en_US',
      country_code: 'USA',
    },
    CA: {
      public_api_key: 'U037MNEMTCH81DFJ',
      script: 'https://cdn1.affirm.com/js/v2/affirm.js',
      locale: `${locale === 'fr' ? 'fr' : 'en'}_CA`,
      country_code: 'CAN',
    },
  };

  const config = configs[country];
  if (!config) return;

  const parseCents = (value) => {
    const n = Number.parseInt(value, 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  // --- Product amount resolution ---

  const resolveProductAmount = (widget) => {
    const newForm = widget.closest('product-new-form');

    if (newForm) {
      const isSubscribe = newForm.querySelector(
        '.js-product-new-form-purchase-type[value="subscribe"]'
      )?.checked;
      const container = newForm.querySelector('.js-purchase-option-price-container');
      const base = parseCents(container?.dataset.basePrice);
      const compare = parseCents(container?.dataset.comparePrice);
      return isSubscribe ? (base || compare) : (compare || base);
    }

    const scope =
      widget.closest('.shopify-section, section, main, .product, .product-single-top') || document;
    const form =
      widget.closest('product-form')?.querySelector('form') ||
      widget.closest('form') ||
      scope.querySelector('form[data-type="add-to-cart-form"]');
    const variantId = parseCents(form?.querySelector('input[name="id"]')?.value);

    if (!variantId) return null;

    for (const el of scope.querySelectorAll(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    )) {
      try {
        const data = JSON.parse(el.textContent);
        if (Array.isArray(data) && data.length && data[0]?.id != null && 'price' in data[0]) {
          const variant = data.find((v) => Number(v.id) === variantId);
          if (variant) return parseCents(variant.price);
        }
      } catch {
        continue;
      }
    }

    return null;
  };

  // --- Sync: only call affirm.ui.refresh() when state actually changes ---

  let ready = false;
  const known = new WeakSet();

  const sync = () => {
    if (!ready) return;

    let changed = false;
    const widgets = document.querySelectorAll('[data-affirm-widget]');

    widgets.forEach((w) => {
      if (!known.has(w)) changed = true;

      if (w.dataset.pageType === 'product') {
        const amount = resolveProductAmount(w);
        if (amount && String(amount) !== w.dataset.amount) {
          w.dataset.amount = String(amount);
          changed = true;
        }
      }
    });

    if (changed && window.affirm?.ui?.refresh) {
      window.affirm.ui.refresh();
    }

    widgets.forEach((w) => known.add(w));
  };

  let timer;
  const scheduleSync = () => {
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  };

  // --- Affirm SDK bootstrap ---

  const bootstrap = (callback) => {
    if (window.affirm?.ui?.ready) {
      callback();
      return;
    }

    window._affirm_config ??= config;

    if (!window.affirm?.checkout || !window.affirm?.ui) {
      ((l, g, m, e, a, f, b) => {
        let d;
        const c = l[m] || {};
        const h = document.createElement(f);
        const n = document.getElementsByTagName(f)[0];
        const k = (obj, name, key) =>
          (...args) =>
            obj[name]._.push([key, args]);

        c[e] = k(c, e, 'set');
        d = c[e];
        c[a] = {};
        c[a]._ = [];
        d._ = [];
        c[a][b] = k(c, a, b);

        for (const key of 'set add save post open empty reset on off trigger ready setProduct'.split(
          ' '
        )) {
          d[key] = k(c, e, key);
        }

        for (const key of ['get', 'token', 'url', 'items']) {
          d[key] = function () {};
        }

        h.async = true;
        h.src = g[f];
        n.parentNode.insertBefore(h, n);
        delete g[f];
        d(g);
        l[m] = c;
      })(window, window._affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready');
    }

    window.affirm.ui.ready(callback);
  };

  // --- Mutation observer: single observer on body, never disconnects ---

  const AFFIRM_SELECTOR =
    '.affirm-promo-widget, .affirm-as-low-as, .affirm-modal, .affirm-popup, .affirm-ala-price';
  const WIDGET_SELECTOR =
    '[data-affirm-widget], product-form, product-new-form, cart-drawer, cart-drawer-items, #main-cart-footer';

  const isAffirmOwned = (node) =>
    node instanceof Element && (node.matches(AFFIRM_SELECTOR) || !!node.closest(AFFIRM_SELECTOR));

  const observer = new MutationObserver((mutations) => {
    for (const { type, target, addedNodes } of mutations) {
      if (type !== 'childList' || isAffirmOwned(target)) continue;

      for (const node of addedNodes) {
        if (!(node instanceof Element) || isAffirmOwned(node)) continue;
        if (node.matches(WIDGET_SELECTOR) || node.querySelector(WIDGET_SELECTOR)) {
          scheduleSync();
          return;
        }
      }
    }
  });

  // --- Init ---

  const init = () => {
    bootstrap(() => {
      ready = true;
      sync();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pdp:variant:change', scheduleSync);
  window.addEventListener('shopify:section:load', scheduleSync);

  document.addEventListener('click', (e) => {
    if (
      e.target.closest(
        'variant-radios label, .js-product-new-form-count-item, .js-product-new-bundle-add, .quantity__button'
      )
    ) {
      scheduleSync();
    }
  });
})();
